<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getHolidays.length > 0 && $store.getters.getHolidaysLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'freshChat_id',
            'freshChat_HolidaysDate',
            'freshChat_HolidaysEn',
            'freshChat_HolidaysUa',
            'freshChat_HolidaysRu',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('freshChat_id.localization_value.value') }}</th>
            <th>{{ $t('freshChat_HolidaysDate.localization_value.value') }}</th>
            <th>{{ $t('freshChat_HolidaysEn.localization_value.value') }}</th>
            <th>{{ $t('freshChat_HolidaysUa.localization_value.value') }}</th>
            <th>{{ $t('freshChat_HolidaysRu.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getHolidays" :key="index">
            <td>
              #{{item.id}}
            </td>

            <td>
              {{ item.date | moment("DD MMM, YYYY") }}
            </td>
            <td>
              {{item.translationStorage.en.text}}
            </td>
            <td>
              {{item.translationStorage.ua.text}}
            </td>
            <td>
              {{item.translationStorage.ru.text}}
            </td>
            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_edit.localization_value.value')"
                            :type="'edit'"
                            @click.native="changeFreshChatPopup(true, item.id)"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getHolidays"
                 :key="index"
            >
              <FreshChatTableMobile
                      :item="item"
                      @changeHolidaysPopup="changeFreshChatPopup(true, item.id)"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getHolidaysCommonList.next_page_url !== null && $store.getters.getHolidays.length > 0"
                    @click.native="$emit('showMore')"
                    :count="$store.getters.getHolidaysCommonList.total - $store.getters.getHolidaysForPage < $store.getters.getHolidaysForPage ?
                    $store.getters.getHolidaysCommonList.total - $store.getters.getHolidaysForPage:
                    $store.getters.getHolidaysForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getHolidaysLoading === false && $store.getters.getHolidays.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <FreshChatHolidaysPopup
            v-if="isModalFreshChatPopup"
            :itemId="itemId"
            :type="'update'"
            @reload="$emit('reload')"
            @close="changeFreshChatPopup(false)"
    />
  </div>
</template>

<script>
  import ManagerButton from "../../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../../mixins/mobileFunctions'
  import NoResult from "../../../../../../../coreComponents/NoResult/NoResult";
  import FreshChatTableMobile from "./FreshChatTableMobile/FreshChatTableMobile";
  import FreshChatHolidaysPopup
    from "@/components/modules/FreshChatModule/popups/FreshChatHolidaysPopup/FreshChatHolidaysPopup";

  export default {
    name: "FreshChatTable",
    components: {
      FreshChatHolidaysPopup,
      FreshChatTableMobile,
      NoResult,
      ManagerButton,
      LinkButton,
      ShowMore,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalFreshChatPopup: false,

      }
    },

    methods: {
      changeFreshChatPopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalFreshChatPopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteHolidays', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
